/**
 * Ring / Pendant Style — SjImageStepper over Thinkspace's style select.
 *
 * Thumbs: assets/top-{code}.png (400×400 from Desktop/bands/grey tops)
 * Config:  window.__SJ_IMAGE_STEPPER_CONFIG__.topImages
 *
 * Raised-filigree / F variants reuse the base style art via the map
 * (e.g. 226 → 249 Eternity, 44 → 252 Journey, 245F → 245).
 *
 * Depends on: sj-3d-builder.js, sj-image-stepper.js/.css
 */
(function () {
  'use strict';

  var B = window.Sj3dBuilder;
  if (!B || typeof window.SjImageStepper !== 'function') return;

  var OPTION_NAMES = ['Ring Style', 'Pendant Style'];
  var HOST_ATTR = 'data-sj-image-stepper-host';
  var ENHANCED_ATTR = 'data-sj-ring-stepper-ready';

  function topImageMap() {
    var m = B.stepperConfig().topImages;
    return m && typeof m === 'object' ? m : {};
  }

  /**
   * Strip cards: name only ("Eternity").
   * Chevron dropdown: "Eternity - 249".
   * Thinkspace option text is often "Eternity (249)" or just "Eternity"; value is the style SKU.
   */
  function parseTopNameSku(value, text) {
    var sku = String(value || '').trim();
    var t = String(text || '').replace(/\s+/g, ' ').trim();
    var name = t;

    var paren = t.match(/^(.+?)\s*\(([^)]+)\)\s*$/);
    if (paren) {
      name = paren[1].trim();
      if (!sku) sku = paren[2].trim();
    } else {
      var leadingSku = t.match(/^(\d+[A-Za-z]?)\s*[-–—]?\s+(.+)$/);
      if (leadingSku) {
        if (!sku) sku = leadingSku[1].trim();
        name = leadingSku[2].trim();
      } else if (t && sku && t.toUpperCase() === sku.toUpperCase()) {
        name = '';
      }
    }

    if (!name) name = sku;
    return { name: name, sku: sku };
  }

  function displayLabel(value, text) {
    return parseTopNameSku(value, text).name;
  }

  function menuLabel(value, text) {
    var p = parseTopNameSku(value, text);
    if (p.name && p.sku && p.name.toUpperCase() !== p.sku.toUpperCase()) {
      return p.name + ' - ' + p.sku;
    }
    return p.name || p.sku;
  }

  function imageUrlFor(value) {
    var map = topImageMap();
    var raw = String(value || '').trim();
    if (!raw) return '';
    var keys = [
      raw,
      raw.toUpperCase(),
      raw.toLowerCase(),
      raw.replace(/F$/i, ''),
      raw.replace(/F$/i, '').toUpperCase(),
    ];
    for (var i = 0; i < keys.length; i++) {
      if (map[keys[i]]) return map[keys[i]];
    }
    return '';
  }

  function readSelectOptions(select) {
    return Array.from(select.options || [])
      .filter(function (opt) {
        return !opt.disabled && String(opt.value || '').trim() !== '';
      })
      .map(function (opt) {
        var value = String(opt.value).trim();
        var text = opt.textContent;
        return {
          value: value,
          label: displayLabel(value, text),
          menuLabel: menuLabel(value, text),
          imageUrl: imageUrlFor(value),
        };
      });
  }

  function enhanceField(field) {
    if (!field || field.getAttribute(ENHANCED_ATTR) === '1') return;
    var select = field.querySelector('select');
    if (!select) return;

    field.setAttribute(ENHANCED_ATTR, '1');
    field.setAttribute(HOST_ATTR, 'ring');

    var optionName = field.getAttribute('data-option') || 'Ring Style';
    var mount = document.createElement('div');
    mount.className = 'sj-image-stepper-mount';
    field.appendChild(mount);

    var stepper = new window.SjImageStepper({
      mountEl: mount,
      kind: 'ring',
      layout: 'strip',
      visibleCount: 3,
      ariaLabel: optionName,
      options: readSelectOptions(select),
      getValue: function () {
        return String(select.value || '');
      },
      setValue: function (value) {
        B.setSelectValue(select, value);
      },
    });

    field._sjRingStepper = stepper;

    var mo = new MutationObserver(function () {
      var next = readSelectOptions(select);
      var prevKey = stepper.options
        .map(function (o) {
          return o.value;
        })
        .join('|');
      var nextKey = next
        .map(function (o) {
          return o.value;
        })
        .join('|');
      if (prevKey !== nextKey) {
        stepper.setOptions(next);
      } else {
        stepper.syncFromValue(undefined, { keepWindow: true });
      }
    });
    mo.observe(select, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'selected'],
    });
    select.addEventListener('change', function () {
      stepper.syncFromValue(undefined, { keepWindow: false });
    });
    field._sjRingStepperMo = mo;
  }

  function scan() {
    OPTION_NAMES.forEach(function (name) {
      document
        .querySelectorAll('[data-option="' + name + '"]')
        .forEach(enhanceField);
    });
  }

  B.bootOnWidget(function (widget) {
    // Widget-scoped observer is enough — step mounts land inside x-3d-product-options.
    B.watchWidget(widget, scan);
  });
})();
